module.exports = [{"code":1,"name":"化学"},{"code":2,"name":"危化品"},{"code":3,"name":"钢材"},{"code":4,"name":"组装"},{"code":99,"name":"其他"}]


//////////////////
// WEBPACK FOOTER
// ./static/json/dictionary/coBusiness.json
// module id = pN/g
// module chunks = 11